import styled from 'styled-components';
import { Media } from 'enums';
import { Text, Button } from 'view/atoms';

export const Page404Styled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  background: radial-gradient(
      circle 226px at -22% 101%,
      rgba(255, 234, 104, 0.85) 60%,
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(
      circle 130px at 106% 23%,
      rgba(248, 221, 127, 1) 0%,
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(
      circle 184px at 66% -6%,
      rgba(202, 144, 255, 0.95),
      rgba(0, 0, 0, 0)
    ),
    linear-gradient(209.77deg, #cf9cff 0%, #8ac7ff 47.4%, #99e798 100%);

  @media ${Media.tablet} {
    background: radial-gradient(
        circle 719px at -22% 75%,
        rgba(255, 234, 104, 0.85) -9%,
        rgba(0, 0, 0, 0)
      ),
      radial-gradient(
        circle 350px at 102% 17%,
        rgba(248, 221, 127, 1) 16%,
        rgba(0, 0, 0, 0)
      ),
      radial-gradient(
        circle 357px at 57% -27%,
        rgba(202, 144, 255, 1) 21%,
        rgba(0, 0, 0, 0)
      ),
      linear-gradient(267.54deg, #cf9cff 0%, #98ceff 45.83%, #99e798 100%);
  }

  @media ${Media.notebook} {
    background: radial-gradient(
        circle 719px at -22% 111%,
        rgba(255, 234, 104, 0.85) 35%,
        rgba(0, 0, 0, 0)
      ),
      radial-gradient(
        circle 454px at 100% 18%,
        rgba(248, 221, 127, 1),
        rgba(0, 0, 0, 0)
      ),
      radial-gradient(
        circle 612px at 60% -30%,
        rgba(202, 144, 255, 0.95),
        rgba(0, 0, 0, 0)
      ),
      linear-gradient(267.54deg, #cf9cff 0%, #98ceff 45.83%, #99e798 100%);
  }

  @media ${Media.desktop} {
    background: radial-gradient(
        circle 719px at -5% 62%,
        rgba(255, 234, 104, 0.85) -13%,
        rgba(0, 0, 0, 0)
      ),
      radial-gradient(
        circle 454px at 100% 13%,
        rgba(248, 221, 127, 0.9) 20%,
        rgba(0, 0, 0, 0) 80%
      ),
      radial-gradient(
        circle 465px at 55% -19%,
        rgba(202, 144, 255, 0.95),
        rgba(0, 0, 0, 0)
      ),
      linear-gradient(267.54deg, #cf9cff 0%, #98ceff 45.83%, #99e798 100%);
  }
`;

export const BackIconStyled = styled.div`
  position: absolute;
  top: 94px;
  left: 20px;

  @media ${Media.tablet} {
    top: 95px;
    left: 40px;
  }

  @media ${Media.notebook} {
    top: 153px;
    left: 75px;
  }

  @media ${Media.desktop} {
    top: 152px;
    left: 150px;
  }
`;

export const PageContent = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & button {
    height: 48px;
  }
  @media ${Media.notebook} {
    width: 343px;
  }
`;

export const ErrorHeader = styled(Text)`
  font-style: normal;
  font-weight: 900;
  font-size: 149px;
  margin-top: 48px;

  @media ${Media.tablet} {
    margin-top: 95px;
  }

  @media ${Media.notebook} {
    font-size: 200px;
    margin-top: 55px;
  }

  @media ${Media.desktop} {
    margin-top: 64px;
    font-size: 288px;
  }
`;

export const ErrorSubheader = styled(Text)`
  margin-top: 23px;

  @media ${Media.notebook} {
    margin-top: 27px;
  }
  @media ${Media.desktop} {
    margin-top: 44px;
  }
`;

export const ErrorDescription = styled(Text)`
  margin-top: 10px;

  @media ${Media.notebook} {
    margin-top: 14px;
  }
`;

export const GoHomeButton = styled(Button)`
  margin-top: 30px;
  margin-bottom: 100px;

  @media ${Media.tablet} {
    margin-bottom: 242px;
  }
  @media ${Media.notebook} {
    margin-top: 54px;
    margin-bottom: 136px;
    min-height: 64px;
  }

  @media ${Media.desktop} {
    margin-bottom: 210px;
  }
`;
